import gql from 'graphql-tag';
import { ErrorsAttributes } from '../constants';
import { GroupCoreAttributes } from './groups';
import { InternalNoteCoreAttributes } from './internalNotes';
import { SiteCoreAttributes } from './sites';
import { UserCoreAttributes, UserMembershipCoreAttributes } from './users';
import { EventCoreAttributesWithContextAndChanges, buildEventFragment } from './events';

export const AccountCoreAttributes = `
id
name
pagesCount
dictionaries
dictionariesLimit
ignoredLinkReasons
longWordsSplit
`;

const AccountExtraAttributes = `
groups {
  ${GroupCoreAttributes}
}
sites {
  ${SiteCoreAttributes}
}
`;

export const AccountQuery = gql`
  query AccountQuery($accountId: String!) {
    account(accountId: $accountId) {
      ${AccountCoreAttributes}
      ${AccountExtraAttributes}
    }
  }
`;

export const AccountWithNotesQuery = gql`
  query AccountWithNotesQuery($accountId: String!) {
    account(accountId: $accountId) {
      ${AccountCoreAttributes}
      internalNotes {
        ${InternalNoteCoreAttributes}
      }
    }
  }
`;

export const AccountActivityQuery = gql`
  query AccountActivityQuery($accountId: String!, $page: Int, $perPage: Int, $eventTypes: [String!], $timeframe: Timeframe, $timeframeStart: Date, $timeframeEnd: Date, $userId: String) {
    account(accountId: $accountId) {
      id
      name
      activity(page: $page, perPage: $perPage, eventTypes: $eventTypes, timeframe: $timeframe, timeframeStart: $timeframeStart, timeframeEnd: $timeframeEnd, userId: $userId) {
        currentPage
        perPage
        totalPages
        totalEntries
        nodes {
          ...AccountActivityEventFragment
        }
      }
    }
  }
  ${buildEventFragment(EventCoreAttributesWithContextAndChanges, 'AccountActivityEventFragment')}
`;

export const AccountsQuery = gql`
  query AccountsQuery {
    accounts {
      nodes {
        ${AccountCoreAttributes}
        ${AccountExtraAttributes}
      }
    }
  }
`;

export const AccountAttributesForRouting = `
  id
  name
  disabled
  featureFlags
  highlightColor
  usesSingleSignOut
  highlightColor
  customDomain {
    id
    name
    usesSsoId
    singleSignOnRequired
  }
  accountType
  renewalFrequency
  nextRenewalAt
  accountContactEmail
  subscribedToPagesCount
  githubEnabled
  gitlabEnabled
  jiraEnabled
  agency {
    id
    name
    customDomain {
      id
      name
      usesSsoId
      singleSignOnRequired
    }
  }
`;

export const AccountsQueryForRouting = gql`
  query AccountsQueryForRouting($accountId: String) {
    accounts {
      nodes {
        ${AccountAttributesForRouting}
      }
    }
    currentUser(accountId: $accountId) {
      ${UserCoreAttributes}
      ${UserMembershipCoreAttributes}
      unreadEventsCount(accountId: $accountId)
    }
    currentShare {
      account {
        id
      }
    }
  }
`;

export const UpdateAccountMutation = gql`
  mutation UpdateAccount($accountId: String!, $dictionaries: [Dictionary!], $ignoredLinkReasons: [String!], $longWordsSplit: Int) {
    updateAccount(accountId: $accountId, dictionaries: $dictionaries, ignoredLinkReasons: $ignoredLinkReasons, longWordsSplit: $longWordsSplit) {
      account {
        ${AccountCoreAttributes}
        ${AccountExtraAttributes}
        ${ErrorsAttributes}
      }
    }
  }
`;


export const dictionaries = [
  'blank',
  'en_US',
  'en_GB',
  'en_CA',
  'en_AU',
  'en_MED',
  'da',
  'nl',
  'fr',
  'fr_CA',
  'finnish',
  'de',
  'it',
  'la',
  'nb',
  'nn',
  'pl',
  'pt',
  'pt_PT',
  'ro',
  'es_US',
  'sv',
  'vi',
  'cy_GB',
];

export const DEFAULT_LONG_WORDS_SPLIT = 20;
